import { Component, CUSTOM_ELEMENTS_SCHEMA, computed, input } from '@angular/core';
import iconLibrary from 'src/app/common/iconLibrary';

export type SortArrowState = 'up' | 'down' | 'other' | 'none';

@Component({
  selector: 'wct-sort-arrows',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './sort-arrows.component.html',
  styleUrl: './sort-arrows.component.scss',
})
export class SortArrowsComponent {
  sortedColumnIndex = input.required<number | null>();
  ascending = input.required<boolean>();
  columnIndex = input.required<number>();

  protected readonly iconLibrary = iconLibrary;

  readonly state = computed<SortArrowState>(() => {
    const sorted = this.sortedColumnIndex();
    if (sorted === null) {
      return 'none';
    }
    if (sorted !== this.columnIndex()) {
      return 'other';
    }
    return this.ascending() ? 'up' : 'down';
  });

  protected readonly iconName = computed(() => (this.state() === 'down' ? 'system/sort-down' : 'system/sort-up'));
  protected readonly iconColor = computed(() => (this.state() === 'up' || this.state() === 'down' ? 'primary' : 'currentColor'));
}
